import { api } from './client';

export interface ScreenerRequest {
  markets?: string[];
  industries?: string[];
  capMin?: number; capMax?: number;
  floatCapMin?: number; floatCapMax?: number;
  priceMin?: number; priceMax?: number;
  changeMin?: number; changeMax?: number;
  volumeMin?: number; volumeMax?: number;
  turnoverMin?: number; turnoverMax?: number;
  peMin?: number; peMax?: number;
  pbMin?: number; pbMax?: number;
  turnoverRateMin?: number; turnoverRateMax?: number;
  fundMin?: number; fundMax?: number;
  sortBy?: string; sortDir?: string;
  page?: number; pageSize?: number;
}

export interface ScreenerItem {
  code: string; name: string; market: string; industry: string;
  price: number; changePct: number; volume: number; turnover: number;
  turnoverRate: number; pe: number; pb: number;
  totalCap: number; floatCap: number; mainNet: number;
}

export interface ScreenerResult {
  list: ScreenerItem[]; total: number; page: number; pageSize: number;
}

export const stockScreener = (params: ScreenerRequest) =>
  api.post<ScreenerResult>('/market/screener', params);
